import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import PersonAvatar from '../customcomponents/PersonAvatar'
import ColType from '../Types'
import { db } from '../firebase/Firebase'
import { Icon, Modal, Tooltip } from 'antd'
import { getColorGradient, getDOKLevelFromGrade, processHtmlWithScopedCss } from '../Util'
import { Document } from '../teacher/edvizv2/Edviz'
import DocumentDelegator from '../edviz/EdvizDelegator'
import HTMLAssessmentViewer from '../teacher/html/components/HTMLAssessmentViewer'
import StudentResource from '../teacher/pacingguide/StudentResource'
import ConditionalTooltip from '../customcomponents/ConditionalTooltip'


class DOKStandardBreakdown extends Component {
    constructor(props) {
        super(props);

        this.studentResourceRef = React.createRef();

        this.state = {
            studentDict: {},
            questionDataDict: {},
            questionData: [],
            questionsMostIncorrect: [],
            questionsMostCorrect: [],
            studentsCompleted: 0,
            visible: false,
            viewingLessonPlanItem: null,
            viewingQuestionIdx: 0,
            standards: [],
            standardsDict: {},
            standardsBeingRetrieved: {},
        }
    }

    componentDidMount() {
        this.getStats()
        this.getStandards()
    }

    componentWillReceiveProps(nextProps) {
        this.getStats()
        this.getStandards()
    }

    getStandards = () => {
        if (!(this.props.quiz &&
            this.props.quiz.quiz &&
            this.props.quiz.quiz.hasOwnProperty('questionStandards') &&
            this.props.quiz.quiz.questionStandards)) {
            return;
        }

        let alreadyHaveStandards = true;
        for (let i = 0; i < this.props.quiz.quiz.questionStandards.length; i++) {
            const standard = this.props.quiz.quiz.questionStandards[i];
            if (!this.state.standardsDict.hasOwnProperty(standard)) {
                alreadyHaveStandards = false;
                break;
            }
        }
        if (alreadyHaveStandards) {
            return;
        }
        let alreadyRetrievingStandards = true;
        for (let i = 0; i < this.props.quiz.quiz.questionStandards.length; i++) {
            const standard = this.props.quiz.quiz.questionStandards[i];
            if (!this.state.standardsBeingRetrieved.hasOwnProperty(standard)) {
                alreadyRetrievingStandards = false;
                break;
            }
        }
        if (alreadyRetrievingStandards) {
            return;
        }

        let standardsBeingRetrieved = {}
        for (let i = 0; i < this.props.quiz.quiz.questionStandards.length; i++) {
            const standard = this.props.quiz.quiz.questionStandards[i];
            standardsBeingRetrieved[standard] = true;
        }
        this.setState({
            standardsBeingRetrieved: standardsBeingRetrieved,
        });

        //console.log('getting standards', this.props.quiz.quiz.questionStandards);

        let standardsPromises = [];
        let standards = [];
        let standardsDict = {};
        for (let i = 0; i < this.props.quiz.quiz.questionStandards.length; i++) {
            const standard = this.props.quiz.quiz.questionStandards[i];
            standardsPromises.push(new Promise((resolve, reject) => {
                db.collection(ColType.standards)
                    .where('standard', '==', standard)
                    .where('standardCategory', '==', this.props.quiz.quiz.standardCategory)
                    .where('standardName', '==', this.props.quiz.quiz.standardName)
                    .limit(1)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            let fullStandard = doc.data();
                            if (!standardsDict.hasOwnProperty(standard)) {
                                standardsDict[standard] = fullStandard;
                                standards.push(fullStandard);
                            }
                        });
                        resolve();
                    })
                    .catch((error) => {
                        reject();
                    });
            }));
        }

        Promise.all(standardsPromises).then(() => {
            //console.log(standards, standardsDict);
            this.setState({
                standards: standards,
                standardsDict: standardsDict,
            });
        });
    }

    showModal = (lessonPlanItem, questionIdx) => {
        this.setState({
            visible: true,
            viewingLessonPlanItem: lessonPlanItem,
            viewingQuestionIdx: questionIdx,
        }, () => {
            if (this.studentResourceRef.current) {
                this.studentResourceRef.current.scrollToQuestion('Question ' + (questionIdx + 1));
            }
        });
    }

    hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    studentDictHasAllStudents = (quiz) => {
        const studentIds = Object.keys(quiz.studentGrades)
        for (let i = 0; i < studentIds.length; i++) {
            const studentId = studentIds[i]
            if (!this.props.studentDict.hasOwnProperty(studentId)) {
                return false
            }
        }
        return true
    }

    areChosenAnswersCorrect = (question, chosenAnswer) => {
        const questionAnswers = question.components[0].answers
        for (let answer of chosenAnswer.answer) {
            if (!questionAnswers[answer].correct) {
                return false
            }
        }
        return true
    }

    isChosenAnswerCorrect = (quiz, questionDoc, questionIdx, chosenAnswersBaseQuiz) => {
        //console.log('isChosenAnswerCorrect', quiz, questionDoc, questionIdx, chosenAnswersBaseQuiz)
        if (quiz.quiz.hasOwnProperty('version') &&
            (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
            return chosenAnswersBaseQuiz['' + questionIdx]
        }

        const uuid = questionDoc.metadata.uuid
        if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
            return false
        }
        const chosenAnswerBaseQuestionDocId = chosenAnswersBaseQuiz[uuid]
        for (let i = 0; i < questionDoc.components[0].answers.length; i++) {
            const answer = questionDoc.components[0].answers[i]
            if (answer.correct && answer.id === chosenAnswerBaseQuestionDocId) {
                return true
            }
        }
        return false
    }

    getStudentsInDOKLevel = (quiz, dokLevel) => {
        let students = []
        let studentsDict = {}
        if (!(quiz && dokLevel)) {
            return students
        }
        if (quiz.quiz.numQuestions === 0) {
            return students
        }
        let count = 0
        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            let studentGrade = quiz.studentGrades[studentId]
            if (quiz.hasOwnProperty('manualGrades') &&
                quiz.manualGrades &&
                quiz.manualGrades.hasOwnProperty(studentId)) {
                let manualGrade = quiz.manualGrades[studentId]
                // no automatic grade, use manual grade as it exists
                // manual grade has same structure as studentGrade
                if (!studentGrade.graded && manualGrade.graded) {
                    studentGrade = manualGrade
                }
            }
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                const finalGrade = studentGrade.finalGrade.grade * 100
                highestDOKLevel = getDOKLevelFromGrade(finalGrade)
            }
            if (highestDOKLevel !== dokLevel) {
                return false
            }
            if (highestDOKLevel === dokLevel && assessmentCompleted) {
                count += 1
                if (!studentsDict.hasOwnProperty(studentId)) {
                    studentsDict[studentId] = true
                    students.push(studentId)
                }
            }
            // dokLevel1 if not completed
            if (!assessmentCompleted && dokLevel === 1) {
                count += 1
                if (!studentsDict.hasOwnProperty(studentId)) {
                    studentsDict[studentId] = true
                    students.push(studentId)
                }
            }
            return false
        })

        return students
    }

    getAverageForQuestionUUID = (quiz, questionUUID) => {
        let students = []
        let studentsDict = {}
        if (!(quiz)) {
            return students
        }
        if (quiz.quiz.numQuestions === 0) {
            return students
        }
        let correctCount = 0
        let count = 0
        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            let studentGrade = quiz.studentGrades[studentId]
            if (quiz.hasOwnProperty('manualGrades') &&
                quiz.manualGrades &&
                quiz.manualGrades.hasOwnProperty(studentId)) {
                let manualGrade = quiz.manualGrades[studentId]
                // no automatic grade, use manual grade as it exists
                // manual grade has same structure as studentGrade
                if (!studentGrade.graded && manualGrade.graded) {
                    studentGrade = manualGrade
                }
            }
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                const finalGrade = studentGrade.finalGrade.grade * 100
                const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                    const questionDoc = quiz.quiz.docs[i]
                    // const dokLevel = questionDoc.metadata.dokLevel
                    let uuid = ''
                    if (quiz.quiz.hasOwnProperty('version') &&
                        (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
                        uuid = '' + i
                    } else {
                        uuid = questionDoc.metadata.uuid
                    }
                    if (uuid !== questionUUID) {
                        continue
                    }
                    if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                        continue
                    }
                    const correct = this.isChosenAnswerCorrect(quiz, questionDoc, i, chosenAnswersBaseQuiz)
                    if (correct) {
                        correctCount += 1
                    }
                    count += 1
                }
            }
            return false
        })

        if (correctCount === 0 || count === 0) {
            return '0.00'
        }
        return ((correctCount / count) * 100).toFixed(2)
    }

    getAverageForQuiz = (quiz) => {
        let students = []
        let studentsDict = {}
        if (!(quiz)) {
            return students
        }
        if (quiz.quiz.numQuestions === 0) {
            return students
        }
        let correctCount = 0
        let count = 0
        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            let studentGrade = quiz.studentGrades[studentId]
            if (quiz.hasOwnProperty('manualGrades') &&
                quiz.manualGrades &&
                quiz.manualGrades.hasOwnProperty(studentId)) {
                let manualGrade = quiz.manualGrades[studentId]
                // no automatic grade, use manual grade as it exists
                // manual grade has same structure as studentGrade
                if (!studentGrade.graded && manualGrade.graded) {
                    studentGrade = manualGrade
                }
            }
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                const finalGrade = studentGrade.finalGrade.grade * 100
                const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                    const questionDoc = quiz.quiz.docs[i]
                    // const dokLevel = questionDoc.metadata.dokLevel
                    let uuid = ''
                    if (quiz.quiz.hasOwnProperty('version') &&
                        (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
                        uuid = '' + i
                    } else {
                        uuid = questionDoc.metadata.uuid
                    }
                    if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                        continue
                    }
                    const correct = this.isChosenAnswerCorrect(quiz, questionDoc, i, chosenAnswersBaseQuiz)
                    if (correct) {
                        correctCount += 1
                    }
                    count += 1
                }
            }
            return false
        })

        if (correctCount === 0 || count === 0) {
            return '0.00'
        }
        return ((correctCount / count) * 100).toFixed(2)
    }

    getStats = () => {
        const quiz = this.props.quiz
        if (!quiz) {
            return
        }
        if (quiz.quiz.numQuestions === 0) {
            return
        }
        if (!(this.props &&
            this.props.studentDict)) {
            return
        }
        //console.log('quiz', quiz)
        /*if (this.state.statsRetrieved) {
            return
        }
    
        this.setState({ statsRetrieved: true })*/

        let stats = {
            questionDataDict: {},
            questionData: [],
            questionsMostIncorrect: [],
            questionsMostCorrect: [],
            studentsCompleted: 0,
        }

        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!this.props.studentDict.hasOwnProperty(studentId)) {
                return false
            }
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            const student = this.props.studentDict[studentId]
            let studentGrade = quiz.studentGrades[studentId]
            if (quiz.hasOwnProperty('manualGrades') &&
                quiz.manualGrades &&
                quiz.manualGrades.hasOwnProperty(studentId)) {
                let manualGrade = quiz.manualGrades[studentId]
                // no automatic grade, use manual grade as it exists
                // manual grade has same structure as studentGrade
                if (!studentGrade.graded && manualGrade.graded) {
                    studentGrade = manualGrade
                }
            }
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                stats.studentsCompleted += 1
                const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                    const questionDoc = quiz.quiz.docs[i]
                    let dokLevel = 1
                    let uuid = ''
                    if (quiz.quiz.hasOwnProperty('version') &&
                        (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
                        uuid = '' + i
                    } else {
                        dokLevel = questionDoc.metadata.dokLevel
                        uuid = questionDoc.metadata.uuid
                    }
                    if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                        continue
                    }
                    const correct = this.isChosenAnswerCorrect(quiz, questionDoc, i, chosenAnswersBaseQuiz)
                    if (correct) {
                        const dokLevelNumber = parseInt(dokLevel, 10)
                        if (dokLevelNumber > highestDOKLevel) {
                            highestDOKLevel = dokLevelNumber
                        }
                    }

                    if (!stats.questionDataDict.hasOwnProperty(i)) {
                        stats.questionDataDict[i] = {
                            correct: 0,
                            incorrect: 0,
                            total: 0,
                        }
                    }
                    if (correct) {
                        stats.questionDataDict[i].correct += 1
                    } else {
                        stats.questionDataDict[i].incorrect += 1
                    }
                    stats.questionDataDict[i].total += 1
                }
            }
        })

        for (let i = 0; i < quiz.quiz.numQuestions; i++) {
            if (!stats.questionDataDict.hasOwnProperty(i)) {
                stats.questionData.push({
                    questionIndex: i,
                    correct: 0,
                    incorrect: 0,
                    total: 0,
                })
                continue
            }
            const questionData = stats.questionDataDict[i]
            stats.questionData.push({
                questionIndex: i,
                correct: questionData.correct,
                incorrect: questionData.incorrect,
                total: questionData.total,
            })
        }

        stats.questionsMostIncorrect = Object.assign([], stats.questionData).sort((a, b) => {
            return b.incorrect - a.incorrect
        })
        stats.questionsMostCorrect = Object.assign([], stats.questionData).sort((a, b) => {
            return b.correct - a.correct
        })

        this.setState({
            stats: stats,
            statsCompleted: true,
        })
    }

    getStudentView = (studentId) => {
        if (!(this.props.quiz &&
            this.props.studentDict &&
            studentId &&
            this.props.studentDict.hasOwnProperty(studentId))) {
            return false
        }
        const quiz = this.props.quiz
        const student = this.props.studentDict[studentId]
        if (!(student && quiz)) {
            return false
        }
        if (quiz.quiz.numQuestions === 0) {
            return false
        }
        if (!quiz.studentGrades.hasOwnProperty(student.id)) {
            return false
        }
        let studentGrade = quiz.studentGrades[student.id]
        if (quiz.hasOwnProperty('manualGrades') &&
            quiz.manualGrades &&
            quiz.manualGrades.hasOwnProperty(student.id)) {
            let manualGrade = quiz.manualGrades[student.id]
            // no automatic grade, use manual grade as it exists
            // manual grade has same structure as studentGrade
            if (!studentGrade.graded && manualGrade.graded) {
                studentGrade = manualGrade
            }
        }
        let assessmentCompleted = studentGrade.graded
        if (this.props.hasOwnProperty('onlyShowCompleted') &&
            this.props.onlyShowCompleted &&
            !assessmentCompleted) {
            return false
        }
        let studentSurveyValue = '';
        if (this.props.quiz.hasOwnProperty('studentSurveys') &&
            this.props.quiz.studentSurveys &&
            this.props.quiz.studentSurveys.hasOwnProperty(student.id) &&
            this.props.quiz.studentSurveys[student.id].completed &&
            this.props.quiz.studentSurveys[student.id].qualitative) {
            studentSurveyValue = this.props.quiz.studentSurveys[student.id].qualitative;
        }
        if (this.props.quiz.hasOwnProperty('manualGrades') &&
            this.props.quiz.manualGrades &&
            this.props.quiz.manualGrades.hasOwnProperty(student.id) &&
            this.props.quiz.manualGrades[student.id] &&
            this.props.quiz.manualGrades[student.id].hasOwnProperty('qualitative') &&
            this.props.quiz.manualGrades[student.id].qualitative) {
            studentSurveyValue = this.props.quiz.manualGrades[student.id].qualitative;
        }
        return <tr key={'tr-' + student.id} style={{ borderBottom: '1px solid #eef2f7' }}>
            <td style={{ border: '1px solid #eef2f7', background: '#f8fafc' }}>
                <div className='flex flex-v-center w-100'>
                    <PersonAvatar
                        person={student}
                        size={'large'}
                        containerClassName="font-16 mr-05"
                        avatarClassName="font-16 font-bold mr-2"
                        personClassName="font-black font-16 ellipsis"
                        personStyle={{ maxWidth: '220px' }}
                    />
                    {studentSurveyValue !== '' ?
                        <div className='ml-auto'>
                            <div
                                title={'Student response to the question: How do you feel about this test?'}
                                style={{ fontSize: '32px' }}>
                                {studentSurveyValue === 'good' ?
                                    <span>😀</span> :
                                    studentSurveyValue === 'somewhatGood' ?
                                        <span>😐</span> :
                                        <span>☹️</span>}
                            </div>
                        </div>
                        : ''}
                </div>
            </td>
            {this.props.hasOwnProperty('showProgress') && this.props.showProgress ?
                <td style={{ border: '1px solid #eef2f7', background: '#fff' }}>
                    {assessmentCompleted ?
                        <div className='font-bold' style={{ color: '#389e0d' }}>
                            Completed
                        </div> :
                        <div className='font-bold' style={{ color: '#2d6a9f' }}>In progress</div>
                    }
                </td> : ''}
            {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapLessonPlanItem, idx) => {
                let lessonPlanItem = null
                if (quiz.quiz.hasOwnProperty('version') &&
                    (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
                } else {
                    lessonPlanItem = quiz.quiz.docs[idx]
                }
                let allCorrect = false
                if (assessmentCompleted) {
                    let studentGrade = quiz.studentGrades[student.id]
                    if (quiz.hasOwnProperty('manualGrades') &&
                        quiz.manualGrades &&
                        quiz.manualGrades.hasOwnProperty(student.id)) {
                        let manualGrade = quiz.manualGrades[student.id]
                        // no automatic grade, use manual grade as it exists
                        // manual grade has same structure as studentGrade
                        if (!studentGrade.graded && manualGrade.graded) {
                            studentGrade = manualGrade
                        }
                    }
                    if (studentGrade.hasOwnProperty('chosenAnswersBaseQuiz')) {
                        allCorrect = this.isChosenAnswerCorrect(quiz, lessonPlanItem, idx, studentGrade.chosenAnswersBaseQuiz)
                    }
                }
                let borderClasses = ' border-right border-top border-bottom'
                if (idx === 0) {
                    borderClasses += ' border-left br-tl-4 br-bl-4'
                } else if (idx === quiz.quiz.numQuestions - 1) {
                    borderClasses += ' br-tr-4 br-br-4'
                } let standard = ''
                let fullStandard = null
                if (this.props.quiz.quiz.hasOwnProperty('questionStandards') &&
                    this.props.quiz.quiz.questionStandards &&
                    idx < this.props.quiz.quiz.questionStandards.length) {
                    if (this.props.quiz.quiz.questionStandards[idx] === 'highlight-text') {
                        standard = (idx > 0 ? this.props.quiz.quiz.questionStandards[idx - 1] :
                            idx < this.props.quiz.quiz.questionStandards.length - 1 ?
                                this.props.quiz.quiz.questionStandards[idx + 1] : '');
                    } else {
                        standard = this.props.quiz.quiz.questionStandards[idx]
                    }
                    if (this.state.standardsDict.hasOwnProperty(standard)) {
                        fullStandard = this.state.standardsDict[standard]
                    }
                }
                return <ConditionalTooltip
                    title={fullStandard ?
                        'Question ' + (idx + 1) + ': Standard ' + standard + ' - ' + fullStandard.title :
                        standard ? standard : undefined
                    }
                    enabled={fullStandard}
                >
                    <td className={'results-table-question-cell purple-border-hover cursor-pointer'}
                        style={{
                            backgroundColor: assessmentCompleted ? allCorrect ? '#fff' : '#ffccc7' : '#fff',
                            border: '1px solid #eef2f7'
                        }}
                        key={'assessment-' + student.id + idx}
                        onClick={(e) => {
                            if (!(this.props.quiz.quiz &&
                                this.props.quiz.quiz.version &&
                                (this.props.quiz.quiz.version === '3.0' ||
                                    this.props.quiz.quiz.version === '4.0')
                            )) {
                                return;
                            }
                            if (!this.props.quiz.quiz.hasOwnProperty('questionStandards')) {
                                return;
                            }
                            this.showModal(lessonPlanItem, idx);
                        }}
                        title={this.props.quiz.quiz.hasOwnProperty('questionStandards') ?
                            'Click to view question' : undefined}>
                        <div className='flex flex-v-center flex-h-center'>
                            {assessmentCompleted ?
                                allCorrect ?
                                    <Icon type='check' className='font-bold' style={{ color: '#389e0d' }} /> :
                                    <Icon type='close' className='font-bold' style={{ color: '#cf1322' }} /> :
                                <div className='text-center' style={{ width: '20px', color: '#94a3b8' }}>-</div>}
                            {/*<div className='ml-1'>{question.metadata.standard.standard}</div>*/}
                        </div>
                    </td>
                </ConditionalTooltip>
            })}
            <td className='text-center'
                style={{ border: '1px solid #eef2f7', borderRight: 'none', background: '#f8fafc', fontWeight: 700, color: assessmentCompleted ? '#1e293b' : '#94a3b8' }}>
                {assessmentCompleted ? (studentGrade.finalGrade.grade * 100).toFixed(2) + '%' : '-'}
            </td>
        </tr>
    }
    sortDOKStudents = (studentIds) => {
        if (!this.props.quiz) {
            return studentIds
        }
        return studentIds.sort((a, b) => {
            if (!this.props.studentDict.hasOwnProperty(a) ||
                !this.props.studentDict.hasOwnProperty(b)) {
                return 0
            }
            let studentA = this.props.studentDict[a]
            let studentB = this.props.studentDict[b]
            if (!this.props.quiz.studentGrades.hasOwnProperty(a) ||
                !this.props.quiz.studentGrades.hasOwnProperty(b)) {
                return 0
            }
            let gradedA = this.props.quiz.studentGrades[a].graded
            let gradedB = this.props.quiz.studentGrades[b].graded
            let gradeA = 0
            let gradeB = 0
            if (this.props.quiz.studentGrades) {
                if (this.props.quiz.studentGrades.hasOwnProperty(a) &&
                    this.props.quiz.studentGrades[a]) {
                    gradedA = this.props.quiz.studentGrades[a].graded
                    if (gradedA) {
                        gradeA = this.props.quiz.studentGrades[a].finalGrade.grade
                    }
                }
                if (this.props.quiz.studentGrades.hasOwnProperty(b) &&
                    this.props.quiz.studentGrades[b]) {
                    gradedB = this.props.quiz.studentGrades[b].graded
                    if (gradedB) {
                        gradeB = this.props.quiz.studentGrades[b].finalGrade.grade
                    }
                }
            }
            if (this.props.quiz.hasOwnProperty('manualGrades') &&
                this.props.quiz.manualGrades) {
                if (this.props.quiz.manualGrades.hasOwnProperty(a) &&
                    this.props.quiz.manualGrades[a]) {
                    gradedA = this.props.quiz.manualGrades[a].graded
                    gradeA = this.props.quiz.manualGrades[a].finalGrade.grade
                }
                if (this.props.quiz.manualGrades.hasOwnProperty(b) &&
                    this.props.quiz.manualGrades[b]) {
                    gradedB = this.props.quiz.manualGrades[b].graded
                    gradeB = this.props.quiz.manualGrades[b].finalGrade.grade
                }
            }
            if (!gradedA &&
                !gradedB) {
                const aGrade = gradeA
                const bGrade = gradeB
                if (aGrade === bGrade) {
                    return studentA.lastName.localeCompare(studentB.lastName);
                }
                return aGrade - bGrade;
            } else if (!gradedA &&
                gradedB) {
                return 1
            } else if (gradedA &&
                !gradedB) {
                return -1
            }
            if (gradeA === gradeB) {
                return studentA.lastName.localeCompare(studentB.lastName);
            }
            return gradeA - gradeB
        })
    }
    render() {
        let dok1Students = []
        let dok2Students = []
        let dok3Students = []
        if (this.props.quiz) {
            dok1Students = this.sortDOKStudents(this.getStudentsInDOKLevel(this.props.quiz, 1))
            dok2Students = this.sortDOKStudents(this.getStudentsInDOKLevel(this.props.quiz, 2))
            dok3Students = this.sortDOKStudents(this.getStudentsInDOKLevel(this.props.quiz, 3))
        }
        return (
            <div className='relative'>
                {this.props.quiz ?
                    <div>
                        <table className='w-100 font-16 results-table' style={{ color: '#1e293b' }}>
                            <thead>
                                <tr>
                                    <th className='pl-2' style={{ background: '#eef2f7', fontSize: 24, fontWeight: 800, color: '#1e293b' }}>Class Report</th>
                                    {this.props.hasOwnProperty('showProgress') && this.props.showProgress ?
                                        <th className='pl-3' style={{ color: '#1e293b', fontWeight: 800 }}>Progress</th>
                                        : ''}
                                    {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapLessonPlanItem, idx) => {
                                        let lessonPlanItem = null
                                        if (this.props.quiz.quiz.hasOwnProperty('version') &&
                                            (this.props.quiz.quiz.version === '3.0' ||
                                                this.props.quiz.quiz.version === '4.0')
                                        ) {
                                        } else {
                                            lessonPlanItem = this.props.quiz.quiz.docs[idx]
                                        }
                                        let standard = ''
                                        let fullStandard = null
                                        if (this.props.quiz.quiz.hasOwnProperty('questionStandards') &&
                                            this.props.quiz.quiz.questionStandards &&
                                            idx < this.props.quiz.quiz.questionStandards.length) {
                                            if (this.props.quiz.quiz.questionStandards[idx] === 'highlight-text') {
                                                standard = (idx > 0 ? this.props.quiz.quiz.questionStandards[idx - 1] :
                                                    idx < this.props.quiz.quiz.questionStandards.length - 1 ?
                                                        this.props.quiz.quiz.questionStandards[idx + 1] : '');
                                            } else {
                                                standard = this.props.quiz.quiz.questionStandards[idx]
                                            }
                                            if (this.state.standardsDict.hasOwnProperty(standard)) {
                                                fullStandard = this.state.standardsDict[standard]
                                            }
                                        }
                                        return <ConditionalTooltip
                                            title={fullStandard ?
                                                'Question ' + (idx + 1) + ': Standard ' + standard + ' - ' + fullStandard.title :
                                                standard ? standard : undefined
                                            }
                                            placement={'bottom'}
                                            enabled={fullStandard}
                                        ><th className='results-table-question-cell cursor-pointer'
                                            onClick={(e) => {
                                                if (!(this.props.quiz.quiz &&
                                                    this.props.quiz.quiz.version &&
                                                    (this.props.quiz.quiz.version === '3.0' ||
                                                        this.props.quiz.quiz.version === '4.0')
                                                )) {
                                                    return;
                                                }
                                                if (!this.props.quiz.quiz.hasOwnProperty('questionStandards')) {
                                                    return;
                                                }
                                                this.showModal(lessonPlanItem, idx);
                                            }}
                                            title={this.props.quiz.quiz.hasOwnProperty('questionStandards') ?
                                                'Click to view question' : undefined}>
                                                <div className='pl-1'>
                                                    <div className='font-14 font-normal' style={{ color: '#94a3b8' }}>QUESTION {idx + 1}</div>
                                                    {lessonPlanItem && lessonPlanItem.metadata.hasOwnProperty('standard') ?
                                                        <div style={{ color: '#475569' }}>{lessonPlanItem.metadata.standard.standard}</div>
                                                        : ''}
                                                    {standard ?
                                                        <div style={{ color: '#475569' }}>{standard}</div>
                                                        : ''}
                                                </div>
                                            </th></ConditionalTooltip>
                                    })}
                                    <th style={{ paddingLeft: '22px', background: '#eef2f7', color: '#1e293b', fontWeight: 800 }}>Grade</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #eef2f7', background: '#eef2f7', fontWeight: 700, color: '#1e293b' }}>Average</td>
                                    {this.props.hasOwnProperty('showProgress') && this.props.showProgress ?
                                        <td style={{ border: '1px solid #eef2f7' }}></td>
                                        : ''}
                                    {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapLessonPlanItem, idx) => {
                                        let lessonPlanItem = null
                                        let uuid = ''
                                        if (this.props.quiz.quiz.hasOwnProperty('version') &&
                                            (this.props.quiz.quiz.version === '3.0' ||
                                                this.props.quiz.quiz.version === '4.0')
                                        ) {
                                            uuid = '' + idx
                                        } else {
                                            uuid = this.props.quiz.quiz.docs[idx].metadata.uuid
                                            lessonPlanItem = this.props.quiz.quiz.docs[idx]
                                        }
                                        const avgStr = this.getAverageForQuestionUUID(this.props.quiz, uuid)
                                        const avgNum = parseFloat(avgStr)
                                        let standard = ''
                                        let fullStandard = null
                                        if (this.props.quiz.quiz.hasOwnProperty('questionStandards') &&
                                            this.props.quiz.quiz.questionStandards &&
                                            idx < this.props.quiz.quiz.questionStandards.length) {
                                            if (this.props.quiz.quiz.questionStandards[idx] === 'highlight-text') {
                                                standard = (idx > 0 ? this.props.quiz.quiz.questionStandards[idx - 1] :
                                                    idx < this.props.quiz.quiz.questionStandards.length - 1 ?
                                                        this.props.quiz.quiz.questionStandards[idx + 1] : '');
                                            } else {
                                                standard = this.props.quiz.quiz.questionStandards[idx]
                                            }
                                            if (this.state.standardsDict.hasOwnProperty(standard)) {
                                                fullStandard = this.state.standardsDict[standard]
                                            }
                                        }
                                        return <ConditionalTooltip
                                            title={fullStandard ?
                                                'Question ' + (idx + 1) + ': Standard ' + standard + ' - ' + fullStandard.title :
                                                standard ? standard : undefined
                                            }
                                            enabled={fullStandard}
                                        >
                                            <td className='purple-border-hover cursor-pointer' style={{
                                                border: '1px solid #eef2f7',
                                                background: getColorGradient(avgNum)
                                            }}
                                                onClick={(e) => {
                                                    if (!(this.props.quiz.quiz &&
                                                        this.props.quiz.quiz.version &&
                                                        (this.props.quiz.quiz.version === '3.0' ||
                                                            this.props.quiz.quiz.version === '4.0')
                                                    )) {
                                                        return;
                                                    }
                                                    if (!this.props.quiz.quiz.hasOwnProperty('questionStandards')) {
                                                        return;
                                                    }
                                                    this.showModal(lessonPlanItem, idx);
                                                }}
                                                title={this.props.quiz.quiz.hasOwnProperty('questionStandards') ?
                                                    'Click to view question' : undefined}>
                                                <div className='text-center'>
                                                    {avgStr}%
                                                </div>
                                            </td></ConditionalTooltip>
                                    })}
                                    <td
                                        style={{ border: '1px solid #eef2f7', borderRight: 'none', background: getColorGradient(parseFloat(this.getAverageForQuiz(this.props.quiz))) }}>
                                        <div className='text-center'>
                                            {this.getAverageForQuiz(this.props.quiz)}%
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}>DOK 1</td>
                                    {this.props.hasOwnProperty('showProgress') && this.props.showProgress ?
                                        <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                        : ''}
                                    {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapLessonPlanItem, idx) => {
                                        return <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                    })}
                                    <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                </tr>
                                {dok1Students.map((studentId, studentIndex) => {
                                    return this.getStudentView(studentId)
                                })}
                                {dok1Students.length === 0 ?
                                    <tr>
                                        <td colSpan={4} style={{ color: '#475569' }}>
                                            There are currently no students reaching DOK 1. This can change as students complete the assessment.
                                        </td>
                                    </tr>
                                    : ''}
                                <tr>
                                    <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}>DOK 2</td>
                                    {this.props.hasOwnProperty('showProgress') && this.props.showProgress ?
                                        <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                        : ''}
                                    {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapLessonPlanItem, idx) => {
                                        return <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                    })}
                                    <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                </tr>
                                {dok2Students.map((studentId, studentIndex) => {
                                    return this.getStudentView(studentId)
                                })}
                                {dok2Students.length === 0 ?
                                    <tr>
                                        <td colSpan={4} style={{ color: '#475569' }}>
                                            There are currently no students reaching DOK 2. This can change as students complete the assessment.
                                        </td>
                                    </tr>
                                    : ''}
                                <tr>
                                    <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}>DOK 3</td>
                                    {this.props.hasOwnProperty('showProgress') && this.props.showProgress ?
                                        <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                        : ''}
                                    {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapLessonPlanItem, idx) => {
                                        return <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                    })}
                                    <td className='pb-1 font-fff font-bold' style={{ background: '#2d6a9f' }}></td>
                                </tr>
                                {dok3Students.map((studentId, studentIndex) => {
                                    return this.getStudentView(studentId)
                                })}
                                {dok3Students.length === 0 ?
                                    <tr>
                                        <td colSpan={4} style={{ color: '#475569' }}>
                                            There are currently no students reaching DOK 3. This can change as students complete the assessment.
                                        </td>
                                    </tr>
                                    : ''}
                            </tbody>
                        </table>
                        <Modal
                            title='View question'
                            width={1000}
                            visible={this.state.visible}
                            onCancel={this.hideModal}
                            footer={null}
                            forceRender={true}
                        >
                            <div>
                                {this.props.parentQuiz &&
                                    this.props.parentQuiz.version &&
                                    (this.props.parentQuiz.version === '3.0' ||
                                        this.props.parentQuiz.version === '4.0') ?
                                    <StudentResource
                                        ref={this.studentResourceRef}
                                        savedState={{ showAllCorrectAnswers: true, survey: 'good' }}
                                        htmlSource={this.props.parentQuiz.docs} />
                                    : ''}
                            </div>
                        </Modal>
                    </div>
                    : ''}
            </div>
        )
    }
}

export default DOKStandardBreakdown
